import { FC } from 'react';
import dayjs from 'dayjs';
import { PersonsV3 } from '@frontend/api-person';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Text, Avatar, Button } from '@frontend/design-system';
import { useTaskFormPatient, useGetUserFromUserId } from '../../../hooks';
import { Citation } from '../../../types';
import { getFullName } from '../../../utils';
import { citationContainerStyle, messageStyle, alignRight, noCitationContainerStyle, eggplantBorder } from './styles';

interface CallIntelCitationProps {
  locationId: string;
  sourceId?: string;
  citation?: Citation;
}

export const CallIntelCitation: FC<CallIntelCitationProps> = ({ citation }) => {
  const { t } = useTranslation('task-center');

  const { patient } = useTaskFormPatient(citation?.patient_id);
  const { data: user } = useGetUserFromUserId(citation?.user_id, !citation?.patient_id);
  const date = citation?.created_at ? dayjs(citation?.created_at).format('MMM DD, YYYY, hh:mm A') : '';
  const personName = patient
    ? PersonsV3.PersonHelpers.getFullName(patient)
    : user
    ? getFullName(user)
    : t('Unknown User');

  const onClickView = async () => {
    // keeping this empty, will add the onClick in the immediate next PR
  };

  if (!citation) {
    return (
      <div css={[noCitationContainerStyle, eggplantBorder]}>
        <Icon name='phone-incoming-small' size={16} />
        <Text size='large' weight='bold'>
          {t('View Details in Call Intel')}
        </Text>
        <Button variant='tertiary' css={alignRight} onClick={onClickView}>
          {t('View')}
        </Button>
      </div>
    );
  }

  return (
    <div css={[citationContainerStyle, eggplantBorder]} onClick={onClickView}>
      <span>
        <Icon name='phone-incoming-small' size={16} />
        <Text size='large' weight='bold'>
          {t('Call Intelligence')}
        </Text>
      </span>
      <span>
        <Avatar name={personName} isUser={!!user} />
        {personName && (
          <Text size='medium' weight='bold'>
            {personName}
          </Text>
        )}
        <Text color='light' size='small' css={alignRight}>
          {date}
        </Text>
      </span>
      <span>
        {citation?.description && (
          <Text size='large' css={messageStyle}>
            {citation?.description}
          </Text>
        )}
      </span>
    </div>
  );
};
